export default "__VITE_ASSET__125ac651__"